import { useTrans } from "@/translations";

import { twMerge } from "tailwind-merge";

import { FILE_STATUS_PARAMS, FileStatus } from "../../../types";

type Props = {
  fileStatus: FileStatus;
  setFileStatus: (value: FileStatus) => void;
};

export const FileStatusSelect: React.FC<Props> = ({
  fileStatus,
  setFileStatus,
}) => {
  const { t } = useTrans();
  return (
    <div className="flex flex-col gap-[6px] pt-1">
      <span className="text-grey6 text-[12px] font-medium">
        {t("libraryPage:fileUploadFileStatus")}
      </span>
      <div className="border-grey3 inline-flex w-fit overflow-hidden rounded border">
        {Object.keys(FILE_STATUS_PARAMS).map((buttonKey, index) => (
          <button
            key={buttonKey}
            type="button"
            onClick={() => setFileStatus(buttonKey as FileStatus)}
            className={twMerge(
              "px-[14px] py-2 text-[12.5px]",
              fileStatus === buttonKey
                ? "bg-black font-semibold text-white"
                : "hover:bg-grey1 bg-white text-[#4a4747]",
              index === 0 && "border-grey3 border-r",
            )}
          >
            {t(FILE_STATUS_PARAMS[buttonKey as FileStatus].statusNameKey)}
          </button>
        ))}
      </div>
    </div>
  );
};
